import { useContext } from 'react';

import { notificationsClient } from 'clients/NotificationsClient/NotificationsClient';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';

type Params = {
  candidateName: string;
  candidatePhoneNumber: string;
};

export const useSendCallMobilePushNotification = () => {
  const { dictionary } = useContext(LocalizationContext);

  return async ({ candidateName, candidatePhoneNumber }: Params) => {
    return notificationsClient.sendPushNotification({
      title: dictionary.tapToCallCandidate(candidateName),
      body: `${candidatePhoneNumber}`,
      data: { url: `tel:${candidatePhoneNumber}` },
    });
  };
};
